import { Component, OnInit, Output, EventEmitter, HostListener, Inject, PLATFORM_ID, Renderer2, Input } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { UrlService } from '../../services/url.service';
import { LoadingService } from '../../services/loading.service';
import { dP_emailRegex, dP_invoiceRegex, dP_tldRegex } from '../../../../../common/functions/regex-standarts';
import { TOKENS } from '../../../environments/environment';
@Component({
    selector: 'app-check',
    templateUrl: 'check.component.html',
    styleUrls: ['./check.component.scss']
})

export class CheckComponent implements OnInit {
    @Output() public loading = new EventEmitter<boolean>();
    @Output() public showNoResult = new EventEmitter<any>();
    @Output() public complete = new EventEmitter<any>();
    public placeholder = 'Ingresa tu dominio, N° de Orden o correo electrónico';
    public isLoading;
    public form: FormGroup;
    private captcha: any;

    @HostListener('window:resize', ['$event'])
    onResize(event: any): void {
        this.setPlaceholder(event.target.innerWidth);
    }

    constructor(
        @Inject(DOCUMENT) private _document: Document,
        @Inject(PLATFORM_ID) private platformId: any,
        private formBuilder: FormBuilder,
        private renderer: Renderer2,
        private apiService: ApiService,
        private reCaptchaService: ReCaptchaV3Service,
        private urlService: UrlService,
        private loadingSrv: LoadingService) {
        this.isLoading = this.loadingSrv.getIsLoading();
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            search: ['', [
                Validators.required
            ]]
        });
        this._setOverlay();
        const query = this.urlService.getValue('query');
        if (query) {
            this.form.controls['search'].setValue(query);
            this.form.markAllAsTouched();
            this.form.markAsDirty();
            this.form.markAsTouched();
            this.onSubmit();
        }
    }

    public onSubmit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.startCaptcha(true);
        }
        let invoice = '';
        let email = '';
        let domain = '';
        const input = this.form.controls['search'].value;
        this.loading.emit(this.isLoading._value);
        this.complete.emit({ show: false, status: '', data: {} });
        this.showNoResult.emit({ show: false, status: '', data: {} });

        if (dP_emailRegex.test(input)) {
            email = input;
        } else if (dP_invoiceRegex.test(input)) {
            invoice = input;
        } else if (dP_tldRegex.test(input)) {
            domain = input;
        } else {
            this.showNoResult.emit({ show: true, status: 'badInput', data: {} });
            return;
        }
        this.loadingSrv.setIsLoading(true);
        this.loading.emit(this.isLoading._value);
        this._setOverlay();

        const formData = new FormData();
        formData.append('invoice', invoice);
        formData.append('email', email);
        formData.append('domain', domain);


        this.apiService.findInvoice(formData).subscribe(res => {
            const values = Object.values(res);
            if (values[0] === 'No found' || values[0] === 'error') {
                this.showNoResult.emit({ show: true, status: values[0], data: values[1] });
            }
            if (values[0] === 'Found finished') {
                this.complete.emit({ show: true, status: values[0], data: values[1] });
            }
            if (values[0] === 'found') {
                this.complete.emit({ show: true, status: values[0], data: values[1] });
            }
        }, err => {
            console.error(err);
        }, () => {
            this.loadingSrv.setIsLoading(false);
            this.loading.emit(this.isLoading._value);
            this._setOverlay();
        });
    }

    private _setOverlay(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        if (this.isLoading) {
            this.renderer.addClass(this._document.body.parentElement, 'overflow-hiden');
        } else {
            this.renderer.removeClass(this._document.body.parentElement, 'overflow-hiden');
        }
    }

    private startCaptcha(state: boolean): void {
        this.reCaptchaService.execute(TOKENS.RECAPTCHA,
            'dialog_tariff',
            (token) => {
                if (state) {
                    this.captcha = token;
                    const element = document.getElementsByClassName('grecaptcha-badge')[0];
                    element.setAttribute('style', element.getAttribute('style') + 'bottom: 118px;');
                }
            });
    }

    private setPlaceholder(width?: number): void {
        const screenWidth = width ?? this._document.body.clientWidth;
        this.placeholder = screenWidth <= 1200
            ? 'Ingresa tu dominio...'
            : 'Ingresa tu dominio, N° de Orden o correo electrónico';
    }
}
